import { useState } from "react";
import { serialEvents } from "../../../mocks/trendData";

function statusStyle(status: string) {
  if (status === "更新中") return "bg-primary-500 text-white";
  if (status === "新开场") return "bg-accent-500 text-white";
  return "bg-secondary-500 text-white";
}

export default function SerialTrack() {
  const [selected, setSelected] = useState(serialEvents[0]);

  return (
    <section id="serial" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
              <i className="ri-play-list-2-line" aria-hidden="true"></i> 连续剧瓜
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              连载瓜 · 全程追踪
            </h2>
            <p className="mt-2 text-sm text-foreground-500 md:text-base">
              每个连载专题的时间线都已整理成串，顺着看就对了。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          {/* 左侧：专题列表 */}
          <div className="flex flex-col gap-3">
            {serialEvents.map((ev) => {
              const active = selected.id === ev.id;
              return (
                <button
                  key={ev.id}
                  type="button"
                  onClick={() => setSelected(ev)}
                  className={`group flex cursor-pointer items-center gap-3 rounded-xl border p-3 text-left transition-colors md:p-4 ${
                    active
                      ? "border-primary-300 bg-primary-50"
                      : "border-background-200 bg-background-50 hover:border-primary-200 hover:bg-background-100"
                  }`}
                >
                  <img
                    src={ev.cover}
                    alt={ev.title}
                    className="h-16 w-14 shrink-0 rounded-lg object-cover object-top md:h-20 md:w-16"
                  />
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-semibold text-foreground-950 md:text-base">
                      {ev.title}
                    </p>
                    <div className="mt-1.5 flex flex-wrap items-center gap-2">
                      <span className={`rounded-md px-2 py-0.5 text-[11px] font-medium ${statusStyle(ev.status)}`}>
                        {ev.status}
                      </span>
                      <span className="text-[11px] text-foreground-400">更新 {ev.updateCount} 期</span>
                      <span className="text-[11px] text-foreground-400">{ev.lastUpdate}</span>
                    </div>
                  </div>
                  {active && (
                    <i className="ri-checkbox-circle-fill text-lg text-primary-500" aria-hidden="true"></i>
                  )}
                </button>
              );
            })}
          </div>

          {/* 右侧：选中专题详情 */}
          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 md:grid-cols-5 md:p-6">
              <div className="md:col-span-2">
                <img
                  src={selected.cover}
                  alt={selected.title}
                  className="h-48 w-full rounded-xl object-cover object-top md:h-full md:min-h-[280px]"
                />
              </div>
              <div className="md:col-span-3">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-md bg-background-200 px-2 py-1 text-xs text-foreground-700">
                    {selected.category}
                  </span>
                  <span className={`rounded-md px-2 py-1 text-xs font-medium ${statusStyle(selected.status)}`}>
                    {selected.status}
                  </span>
                  <span className="text-xs text-foreground-400">热度 {selected.heat}</span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {selected.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">
                  {selected.desc}
                </p>

                <ol className="mt-5 space-y-0">
                  {selected.nodes.map((node, i) => (
                    <li key={i} className="relative flex gap-3 pb-4">
                      {i < selected.nodes.length - 1 && (
                        <span className="absolute left-[5px] top-5 bottom-0 w-px bg-background-300"></span>
                      )}
                      <span className="mt-1.5 h-3 w-3 shrink-0 rounded-full bg-accent-400 ring-4 ring-accent-100"></span>
                      <div className="min-w-0">
                        <span className="mr-2 font-mono text-xs font-semibold text-primary-700">
                          {node.time}
                        </span>
                        <p className="inline text-sm text-foreground-700">{node.label}</p>
                      </div>
                    </li>
                  ))}
                </ol>

                <div className="mt-3 flex flex-wrap gap-3">
                  <a
                    href="#latest"
                    className="inline-flex whitespace-nowrap items-center gap-1 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
                  >
                    查看全部脉络 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </a>
                  <button
                    type="button"
                    className="inline-flex whitespace-nowrap items-center gap-1 rounded-full border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100"
                  >
                    <i className="ri-notification-3-line" aria-hidden="true"></i> 追更提醒
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}